var translation = {
	Navatar: {
		header: "Perfil da AWS",
		subheader: "Seu perfil ajuda a melhorar suas interações com experiências selecionadas da AWS.",
		profileButtonText: "Visualizar perfil",
		logOutText: "Sair",
		logInText: "Conecte-se",
		createProfileText: "Criar perfil",
		federateLoginModalTitle: "Use o Midway para acessar seu perfil da AWS",
		federateLoginModalFirstDescription: "Como funcionário da Amazon, recomendamos usar a Midway para acessar seu perfil da AWS. Esse método recomendado pela segurança fornece uma integração perfeita aos sistemas internos.",
		federateLoginModalSecondDescription: "Você está vendo essa mensagem porque fez login com um endereço de e-mail da Amazon usando o ID do builder AWS. Esse aviso aparecerá toda vez que você fizer login até mudar para a Midway ou optar por continuar com seu login atual.",
		federateLoginModalPrimaryButton: "Faça login com a Midway",
		federateLoginModalSecondaryButton: "Continue com o ID do builder AWS"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
